import { legacyColors, legacyShadows } from '~/legacyTheme';
import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    notificationNum: {
      position: 'absolute',
      top: '6px',
      left: '27px',
      padding: '4px',
      height: '20px',
      minWidth: '20px',
      color: legacyColors.white,
      backgroundColor: '#f44336',
      borderRadius: '50%',
      fontSize: '0.75rem',
      lineHeight: '0.75rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    popper: {
      '&.MuiTooltip-popper .MuiTooltip-tooltip': {
        color: 'inherit',
        minWidth: '600px',
        backgroundColor: legacyColors.white,
        borderRadius: 0,
        boxShadow: legacyShadows.drop1,
        padding: 0,
        margin: 0,
        marginTop: theme.spacing(0.5),
        fontWeight: 'normal',
      },
    },
  };
};
